module.exports = "<div *ngIf=\"alerts\" class=\"alerts\" role=\"alert\"> <div *ngFor=\"let alert of alerts\" [ngClass]=\"{'alert.position': true, 'toast': alert.toast}\"> <ngb-alert *ngIf=\"alert && alert.type && alert.msg\" [type]=\"alert.type\" (close)=\"closeAlert(alert)\"> <pre class=\"alert-message\" [innerHTML]=\"alert.msg\"></pre> </ngb-alert> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/generic/alert/alert.component.html
// module id = 217
// module chunks = 0